//扩展vue
import wxFn from './wxFn'
import weui from 'weui.js'
import native from './native'
import util from './util'
import valideEmail from "./valideEmail";

import postHttp from './postHttp'
import ployvPostHttp from './ployvPostHttp'
import http from './http'
// import appId from '@/api/index'
// wxFn.wxConfig();

const extendFn = {
  install(Vue) {
    Vue.prototype.$wxFn = wxFn;
    Vue.prototype.$native = native;
    Vue.prototype.$weui = weui;
    Vue.prototype.valideEmail = valideEmail;
    Vue.prototype.$util = util;
    Vue.prototype.$postHttp = postHttp;
    Vue.prototype.$ployvPostHttp = ployvPostHttp;
    Vue.prototype.$http = http;
    Vue.prototype.getQueryString = function (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    };
  }
};
export default extendFn;



// WEBPACK FOOTER //
// ./src/plugin/extendFn/index.js